import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-campus-life', templateUrl: './campus-life.component.html', styleUrls: ['./campus-life.component.scss'] })
export class CampusLifeComponent implements OnInit { constructor() { } ngOnInit(): void { } }
